import { Link } from "react-router-dom";
import { Layers } from "lucide-react";
import { useCategories } from "@/hooks/ecommerce/useCategories";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";

/**
 * Dropdown "Coleções" que exibe as categorias com imagem.
 * Decisão do escopo: o menu mostra categorias (não a tabela collections)
 * porque o usuário quer levar diretamente a /categoria/:slug.
 */
const CategoriesMegaMenu = () => {
  const { data: categories = [] } = useCategories();

  if (!categories.length) return null;

  return (
    <NavigationMenu>
      <NavigationMenuList>
        <NavigationMenuItem>
          <NavigationMenuTrigger className="bg-transparent text-sm font-medium text-muted-foreground transition-colors hover:text-primary data-[state=open]:text-primary">
            Coleções
          </NavigationMenuTrigger>
          <NavigationMenuContent>
            <div className="grid w-[640px] max-w-[90vw] gap-3 p-5 sm:grid-cols-3">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/categoria/${cat.slug}`}
                  className="group flex items-center gap-3 rounded-lg border border-border bg-card p-3 transition-all hover:border-primary hover:shadow-card"
                >
                  <div className="h-14 w-14 shrink-0 overflow-hidden rounded-md bg-muted">
                    {cat.image_url ? (
                      <img
                        src={cat.image_url}
                        alt={cat.name}
                        loading="lazy"
                        className="h-full w-full object-cover transition-transform group-hover:scale-105"
                      />
                    ) : (
                      <div className="flex h-full w-full items-center justify-center text-muted-foreground">
                        <Layers className="h-5 w-5" />
                      </div>
                    )}
                  </div>
                  <div className="min-w-0">
                    <p className="truncate text-sm font-semibold text-foreground group-hover:text-primary">
                      {cat.name}
                    </p>
                    {cat.description && (
                      <p className="truncate text-xs text-muted-foreground">
                        {cat.description}
                      </p>
                    )}
                  </div>
                </Link>
              ))}
            </div>
          </NavigationMenuContent>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  );
};

export default CategoriesMegaMenu;